import { useTranslation } from "react-i18next";
import { CustomButton } from "../../components";
import "./styles.scss";

const ConfirmationPopup = ({
  show,
  icon,
  heading,
  description,
  cancelButtonText,
  onClickCancel,
  confirmButtonText,
  onClickConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`confirmation-popup-container ${show ? "show" : "hide"}`}>
      <div className="confirmation-popup-content">
        <div className="icon-wrapper">
          <img src={icon} alt="Error" />
        </div>
        <h1 className="heading">{t(heading)}</h1>
        <p className="description">{t(description)}</p>
        <div className="button-group">
          <CustomButton
            text={t(cancelButtonText)}
            btnVariant="btn-primary-50"
            onClick={onClickCancel}
          />
          <CustomButton text={t(confirmButtonText)} onClick={onClickConfirm} />
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPopup;
